import { Button, Modal } from "react-bootstrap";
import SouvenirStatusImg from "../../../../../../../assets/images/starShowcase/shirt.png";
import noImage from "../../.../../../../../../../assets/images/settings/no-image.png";
import "./StarShowcaseModal.css";
import swal from "sweetalert";
import axios from "axios";
import { serverInfo } from "../../../../../../../App";
import { useContext } from "react";

const StarShowcaseModal = (props) => {

  const { imageCdnUrl } = useContext(serverInfo);

  const { handleView } = props;

  const handleDeliveryStatus = (status) => {
    axios
      .get(`/api/admin/souvenir/status/change/${status}/${props.souvenir?.id}`)
      .then((res) => {
        if (res.data.status === 200) {
          swal("Product Status", res.data.message, "success");
          handleView(props?.souvenir?.id);
        }
      });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="my-modal-souvenir"
      centered
    >
      <Modal.Body className="bg-black">
        <div className="p-4">
          <div className="d-flex justify-content-between">
            <h2 className="headingStatus">Souvenir Status</h2>
            <div className="">
              <button className="close-button" onClick={props.onHide}>
                X
              </button>
            </div>
          </div>

          <div className="underlineBlack"></div>

          <div className="row my-4">
            <div className="col-md-5">
              <img
                src={
                  props.souvenir?.image
                    ? imageCdnUrl + props.souvenir?.image
                    : noImage
                }
                alt=""
                className="img-fluid w-100"
              />
            </div>
            <div className="col-md-7">
              <div className="text-light">
                <h6>Name</h6>
                <p>{props.souvenir?.name}</p>
              </div>
              <div className="text-light">
                <h6>Mobile No</h6>
                <p>{props.souvenir?.mobile_no}</p>
              </div>
              <div className="text-light">
                <h6>Address</h6>
                <p>
                  {props.souvenir?.area}, {props.souvenir.city?.name},{" "}
                  {props.souvenir.state?.name}, {props.souvenir.country?.name}
                </p>
              </div>
              <div className="text-light">
                <h6>Total Amount</h6>
                <p>{props.souvenir?.total_amount} $</p>
              </div>
              <div className="text-light">
                <h6>Short Description</h6>
                <p>{props.souvenir?.description}</p>
              </div>
              {props.souvenir?.status >= 2 ? (
                <div className="text-light">
                  <h6>Status</h6>

                  <select
                    name="data"
                    id="data"
                    className="form-control"
                    style={{ background: " #bbc2d6", color: "black" }}
                    onChange={(e) => handleDeliveryStatus(e.target.value)}
                    value={props.souvenir?.status}
                  >
                    <option value="">--Select--</option>
                    <option value="3">Processing</option>
                    <option value="4">Product Received</option>
                    <option value="5">Processing</option>
                    <option value="6">Out for Delivery</option>
                    <option value="7">Delivered</option>
                  </select>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default StarShowcaseModal;
